export default __webpack_public_path__ + "static/media/appbrella-logo.7be38be6.svg";